import useSWR from 'swr'

import { useCallMutation } from '@/common/api/client'
import { apiPutFetcher } from '@/common/api/fetcher'
import {
  ListSchedulesResponse,
  ListSchedulesVars,
  MediaAnalysisAutomationApiPath,
  UpsertScheduleResponse,
  UpsertScheduleVars
} from '@/common/api/params/mediaAnalysisAutomation'

export const useMediaAnalysisAutomationListApi = (vars: ListSchedulesVars | undefined) => {
  return useSWR<ListSchedulesResponse, Response, [string, ListSchedulesVars] | undefined>(
    vars ? [MediaAnalysisAutomationApiPath.LIST_SCHEDULES, vars] : undefined
  )
}

export const useUpsertMediaAnalysisAutomationApi = (options?: {
  onSuccess?: (response: UpsertScheduleResponse) => void
  onError?: (error: Response) => void
}) => {
  return useCallMutation<UpsertScheduleResponse, UpsertScheduleVars>(
    MediaAnalysisAutomationApiPath.UPSERT_SCHEDULE,
    { ...options },
    apiPutFetcher
  )
}
